import type { CancellationSource } from '@change-corgi/middle-end-gql-schema';

export type { CancellationSource };

// Values of the GQL `CancellationSource` enum, UPPER_CASE per the schema's enum convention.
export const CANCELLATION_SOURCE_ACCOUNT_SETTINGS = 'ACCOUNT_SETTINGS';
export const CANCELLATION_SOURCE_EASY_CANCEL = 'EASY_CANCEL';

export const CANCELLATION_SOURCE_USER_SUPPORT_SINGLE = 'USER_SUPPORT_SINGLE';

/** The GraphQL enum's members plus the tracking-only `USER_SUPPORT_SINGLE`. */
export type CancellationTrackingSource = CancellationSource | typeof CANCELLATION_SOURCE_USER_SUPPORT_SINGLE;

// Tracking carries the lowercase form, matching what payment_service stores on
// subscriptions.cancellation_source and echoes back on the cancellation webhook — so the events
// corgi emits and the ones derived from the webhook carry identical values.
// See TRACKING_EVENTS.md's subs_customer_cancellation section.
const CANCELLATION_SOURCE_TO_TRACKING_VALUE = {
	ACCOUNT_SETTINGS: 'account_settings',
	EASY_CANCEL: 'easy_cancel',
	USER_SUPPORT_SINGLE: 'user_support_single',
} as const satisfies Record<CancellationTrackingSource, string>;

export function cancellationSourceToTrackingValue(source: CancellationTrackingSource): string {
	return CANCELLATION_SOURCE_TO_TRACKING_VALUE[source];
}
